<template>
  <div class="dashboard_paddd">
    <Dashboard />
  </div>
</template>

<script>
import Dashboard from "./Dashboard/Dashboard.vue";
export default {
  components: {
    Dashboard,
  },
};
</script>

<style scoped>
.dashboard_paddd {
  padding: 62px 38px 60px 38px;
  overflow: auto;
  height: calc(100vh - 66px);
}
</style>
